import React, { useEffect, useMemo, useState } from "react";
import Banner from "../../layouts/Banner/Banner";
import ProductCategories from "../../layouts/ProductCategories/ProductCategories";
import AboutSection from "../../layouts/AboutSection/AboutSection";
import Images from "../../asset/images";
import { useCategoryStore } from "../../stores/categories/useCategoryStore";
import { useLanguageStore } from "../../stores/Language/useLanguageStore";
import defaultMenuData from "../../data/menuItems.json";
import capitalizeFirstLetter from "../../utils/capitalizeFirstLetter";
import { usePageSections } from "../../hooks/usePageSections";
import SectionRenderer from "../../components/SectionRenderer/SectionRenderer";

const Home = () => {
  const [category, setCategory] = useState([]);
  const { categoryJewelry } = useCategoryStore();
  const { currentLanguage, translations } = useLanguageStore();
  const { sections } = usePageSections("home");
  const currentTranslations = useMemo(() => {
    return translations[currentLanguage] || defaultMenuData.content;
  }, [translations, currentLanguage]);

  const transformed = (datas) => {
    return datas
      .filter((data) => data.slug !== "chua-phan-loai") //
      .map((data) => {
        return {
          id: data.id,
          image: data.image || null,
          name: currentTranslations?.JewelryDropDown?.[data.name] || data.name,
          href: `/products/category/${capitalizeFirstLetter(data.slug)}`,
        };
      });
  };
  useEffect(() => {
    let itemsTranformed = transformed(categoryJewelry);
    setCategory(itemsTranformed);
  }, [categoryJewelry, currentTranslations]);

  if (sections?.length) {
    return (
      <div>
        {sections.map((section) => (
          <SectionRenderer key={section.id} section={section} />
        ))}
      </div>
    );
  }

  return (
    <div>
      <Banner
        showBtn={true}
        imgSrc={Images.bannerImage}
        to={`/products/category`}
      />
      <ProductCategories items={category} showTittle={true} />
      <AboutSection />
    </div>
  );
};

export default Home;
